import React, { useState, useEffect } from "react";
import axios from "axios";
import { distributionUrl } from "../../Config/url";
import { useAxiosConfigGlobal } from "../../Config/axios";
import { IconController } from "../../Scripts/ImgController";
import assets from "../../../assets/assets";
import Song from "./Song";
import Ripples from "react-ripples";
import { useLocation } from "react-router-dom";
const Album = ({ album, selectedAlbums, selectedSongs, oneRingRulesAll }) => {
  const axiosConfig = useAxiosConfigGlobal();
  const [albumChecked, setAlbumChecked] = useState(false);
  const [songsVisible, setSongsVisible] = useState(false);
  const [songs, setSongs] = useState([]);
  const location = useLocation();
  const context = location.pathname.includes("/karaoke") ? "karaoke" : "music";
  const clickHandler = (id) => {
    if (album.release_type === "album") {
      if (songs.length === 0) {
        axios
          .get(
            distributionUrl + "panel-api/oauth/songs?filter[album_id]=" + id,
            axiosConfig
          )
          .then((res) => {
            setSongs(res.data.data);
          })
          .catch((err) => {
            if (err.response.status === 401) {
              oneRingRulesAll("logout");
            }
          });
      }
      setSongsVisible(!songsVisible);
    }
  };
  useEffect(() => {
    if (selectedAlbums.includes(album.id)) {
      setAlbumChecked(true);
    }
    if (
      selectedSongs.includes(album.id) &&
      (album.release_type === "single" || context === "karaoke")
    ) {
      setAlbumChecked(true);
    }
  }, []);

  const albumUncheckHandler = (id, releaseType) => {
    if (releaseType === "album") {
      const index = selectedAlbums.indexOf(id);
      if (index > -1) {
        selectedAlbums.splice(index, 1);
      }
    } else {
      const index = selectedSongs.indexOf(id);
      if (index > -1) {
        selectedSongs.splice(index, 1);
      }
    }

    setAlbumChecked(false);
  };
  const albumCheckHandler = (id, releaseType) => {
    releaseType === "album" ? selectedAlbums.push(id) : selectedSongs.push(id);
    setAlbumChecked(true);
  };

  const songsMap = songs.map((song) => {
    return <Song song={song} selectedSongs={selectedSongs} key={song.id} />;
  });
  return (
    <div>
      <div className="flex flex-row gap-2 items-center">
        {albumChecked ? (
          <div
            onClick={() => {
              albumUncheckHandler(album.id, album.release_type);
            }}
          >
            <IconController
              src={assets.svg.checkboxChecked}
              className="w-5 h-5 cursor-pointer"
            />
          </div>
        ) : (
          <div
            className="checkbox-unchecked"
            onClick={() => {
              albumCheckHandler(album.id, album.release_type);
            }}
          ></div>
        )}
        <Ripples color="#0061FF40" during={600} className="w-full py-2 ">
          <div
            className={`flex flex-row flex-1 ${
              album.release_type === "album" ? "cursor-pointer" : ""
            }`}
            onClick={() => {
              clickHandler(album.id);
            }}
          >
            <h5 className="text-xs flex-1">{album.title}</h5>
            {album.release_type === "album" ? (
              <IconController
                src={assets.svg.chevronDown}
                className={`w-4 h-4 ${songsVisible ? "rotate-180" : ""}`}
              />
            ) : (
              ""
            )}
          </div>
        </Ripples>
      </div>
      <div
        className={`pl-8 flex flex-col ${
          songsVisible ? "pt-3 gap-3" : "hidden"
        }`}
      >
        {songsMap}
      </div>
    </div>
  );
};
export default Album;
